// ----- phase-small-findings-batch-1 (item 5) -----
//
// Client-side size caps for the Company Profile branding uploads.
//
// The SERVER is the authority and always was: `src/routes/company-profiles.ts`
// rejects an oversize logo (LOGO_MAX_BYTES) or letterhead (LETTERHEAD_MAX_BYTES)
// with a 400 `ValidationError` whose message the branding panel already shows.
// What was missing is that nothing checked BEFORE the upload — so choosing a
// 40 MB letterhead meant uploading all 40 MB and only then being told it was
// too big. These constants MIRROR the server's; if the server's change, change
// these in the same commit (the unit test names the file).
export const LOGO_MAX_BYTES = 2 * 1024 * 1024;
export const LETTERHEAD_MAX_BYTES = 10 * 1024 * 1024;

/** `2 MB`, `10 MB`, `1.4 MB` — used in both the limit and the actual size. */
export function formatMb(bytes: number): string {
  const mb = bytes / (1024 * 1024);
  // Whole numbers read as "2 MB"; anything else keeps one decimal so a
  // 2.1 MB file is not rounded into looking like it was within the limit.
  return `${Number.isInteger(mb) ? mb : Math.round(mb * 10) / 10} MB`;
}

/**
 * The rejection message for a file that is too large, or null when it fits.
 * NAMES the file, the limit and the file's actual size — "too large" alone
 * leaves the reader guessing by how much.
 */
export function oversizeMessage(
  file: { name: string; size: number },
  maxBytes: number,
  label: string,
): string | null {
  if (file.size <= maxBytes) return null;
  return `${label} "${file.name}" is ${formatMb(file.size)} — over the ${formatMb(maxBytes)} limit. Nothing was uploaded; the current ${label.toLowerCase()} is unchanged.`;
}
